export default __webpack_public_path__ + "static/media/bagsshopping-1.2e1387a4.svg";